// extracted by mini-css-extract-plugin
var _1 = "styles-module__addIcon___cSLXb";
var _2 = "styles-module__addPhotoSquare___joekT";
var _3 = "styles-module__emptyPhotoContainer___qt3Lt";
var _4 = "styles-module__photosTab___ky6Vn";
var _5 = "styles-module__uploadedImg___aZEU_";
var _6 = "styles-module__uploadedPhoto___GGxFg";
export { _1 as "addIcon", _2 as "addPhotoSquare", _3 as "emptyPhotoContainer", _4 as "photosTab", _5 as "uploadedImg", _6 as "uploadedPhoto" }
